import { localesBySite } from '@ocp-zmarta/content-lib'

export function localizedDateFormat (dateObj, site) {
  if (!dateObj || !site) {
    return null
  }

  try {
    return new Date(dateObj).toLocaleDateString(localesBySite[site], {
      month: 'long', day: 'numeric', year: 'numeric'
    })
  } catch (e) {
    console.log(e)
    return ''
  }
}
